import React from 'react';
import PropTypes from 'prop-types';

import whitelabel_homeSVG from '../../../images/whitelabel_homeSVG.svg'; 
import whitelabel_homeSVG2 from '../../../images/whitelabel_homeSVG2.svg'; 
import Image from '../../elements/Image'; 
import Button from '../../elements/Button'; 
import Point from '../../elements/Point'; 
import './style.scss';

function WhiteLabel(props) {
  const { title, description, points, image, locale} = props; 


  return (
    <div className="whitelabel-container container">
      <div className="whitelabel-wrapper row g-0"> 
        <div className="whitelabel-image order-12 order-xl-1 col-xl-6"> 
          <div className="flip-container col-12 row g-0 justify-content-around justify-content-xl-center align-items-start">
              <Image src={whitelabel_homeSVG2} alt="white label solution" className="back" /> 
              <Image src={whitelabel_homeSVG} alt="white label solution" className="front"/> 
          </div>
        </div> 
        <div className="text-panel order-xl-2 row g-0 col-xl-6">
          <div className="text-panel-upper col-12 col-lg-6 col-xl-12"> 
            <h2>{title}</h2>
            { locale === '' &&
              <>
              <p className="segment-text white-text">With our <a className='linktext' href="https://docs.checkbook.io/docs/products/marketplace/">White Label Marketplace</a> Implementation, we give you complete control over colors, emails, verbiage, and more. Our <a className='linktext' href="https://docs.checkbook.io/docs/create-a-marketplace">white label solution</a> provides a complete set of building blocks to support virtually any business model from mass disbursements to financial service marketplaces.</p>
              <p className="segment-text white-text">Whether you're a <a className='linktext' href="https://docs.checkbook.io/docs/products/marketplace/">marketplace</a> for landlords, freelances, or gig economy workers, or even building an accounting platform, <a className='linktext' href="https://docs.checkbook.io/docs/create-a-marketplace">Checkbook</a> has the solution for you. </p>    
              </>
            }
            { locale === 'en-ca' &&
              <>
              <p className="segment-text white-text">With our <a className='linktext' href="https://docs.checkbook.io/docs/products/marketplace/">White Label Marketplace</a> Implementation, we give you complete control over colours, emails, verbiage, and more. Our <a className='linktext' href="https://docs.checkbook.io/docs/create-a-marketplace">white label solution</a> provides a complete set of building blocks to support virtually any business model from mass disbursements to financial service marketplaces.</p>
              <p className="segment-text white-text">Whether you're a <a className='linktext' href="https://docs.checkbook.io/docs/products/marketplace/">marketplace</a> for landlords, freelances, or gig economy workers, or even building an accounting platform, <a className='linktext' href="https://docs.checkbook.io/docs/create-a-marketplace">Checkbook</a> has the solution for you. </p>    
              </>
            }
            { locale === 'fr-ca' &&
              <>
              <p className="segment-text white-text">Avec la <a className='linktext' href="https://docs.checkbook.io/docs/products/marketplace/">platforme PayFac en marque blanche de Checkbook</a>, nous donnons aux clients un contrôle total sur les couleurs, les e-mails, le contenu et plus encore. Notre large gamme d'options de paiement permet des solutions de paiement personnalisées pour tous les besoins de l'entreprise, des décaissements massifs aux marchés de services financiers.</p>
              <p className="segment-text white-text">Que vous soyez une <a className='linktext' href="https://docs.checkbook.io/docs/products/marketplace/">place de marché</a> pour les propriétaires, les locataires ou les travailleurs de l'économie des petits boulots, ou même la construction d'une plate-forme comptable, <a className='linktext' href="https://docs.checkbook.io/docs/create-a-marketplace">Checkbook</a> a la solution pour vous.</p>    
              </>
            }
            {/* { description.map((text, i) => {
              return (
                <p className="segment-text white-text">{text.paragraph}</p> 
              )
            })} */}
          </div> 
          { points.map((point, i) => {
            return (
              <Point 
              key={point.text}
              className="point col-md-6 col-lg-3 col-xl-6" 
              image={point.image} 
              header={point.header} 
              text={point.text} 
              button={point.button} 
              option="transparent"
              /> 
            )
          })} 
        </div> 
      </div> 
    </div>
  );
}

WhiteLabel.propTypes = {
  title: PropTypes.string.isRequired, 
  description: PropTypes.array.isRequired, 
  points: PropTypes.array.isRequired, 
  image: PropTypes.string.isRequired
};

export default WhiteLabel;


